import { IconDefinitions, Submenu, SubmenuNavigationItem } from '../../components';
import { routes } from '../../app/routes';
import { UserService } from '../../services';
import { Roles } from '../../models';

export function CTEyeRootSubmenu() {
  const isAdmin = UserService.isInRole(Roles.admin);
  const canViewRegistered = UserService.isInAnyRole([Roles.admin, Roles.staff, Roles.dataAnalyst]);

  const submenus: SubmenuNavigationItem[] = [
    {
      label: "Dashboard",
      icon: IconDefinitions.CTEye,
      url: routes.cteye,
      activeMatch: routes.cteye,
    },
    ...(isAdmin ? [
      {
        label: "Unassigned",
        icon: IconDefinitions.circleExclamation,
        url: routes.cteyePendingApprovals,
        activeMatch: routes.cteyePendingApprovals,
      },
    ] : []),
    ...(canViewRegistered ? [
      {
        label: "Registered",
        icon: IconDefinitions.CTEyeClient,
        url: routes.cteyeRegisteredAgents,
        activeMatch: routes.cteyeRegisteredAgents,
      },
      {
        label: "Inspections",
        icon: IconDefinitions.chartLineUp,
        url: routes.cteyeUploadSessions,
        activeMatch: routes.cteyeUploadSessions,
      },
    ] : []),
  ];

  return <Submenu items={submenus}></Submenu>;
}

export default CTEyeRootSubmenu;